import { Button } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Download from 'assets/download-active.svg';
import Tick from 'assets/tick.svg';
import EmailPreview from 'components/signaturePreview/email/emailPreview';
import html2canvas from 'html2canvas';
import { useEffect } from 'react';
// import { useUserActions } from 'hooks';
import { useRecoilValue } from 'recoil';
import { verifyStatusAtom } from '_state/signature';

const DownloadEmail = () => {
  // const userActions = useUserActions();
  const verifyStatus = useRecoilValue(verifyStatusAtom);

  useEffect(() => {
    setTimeout(() => {
      const divElement = document.getElementById('signatureMarkup');

      // render the signature and send mail to the user
      if (divElement) {
        html2canvas(divElement, {
          allowTaint: true,
          useCORS: true,
        })
          .then(canvas => {
            canvas.style.display = 'none';
            document.body.appendChild(canvas);
            return canvas;
          })
          .then(canvas => {
            const imageDataUrl = canvas.toDataURL('image/jpg');
            const binaryString = atob(imageDataUrl.split(',')[1]);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }
            const hexString = Array.from(bytes, function (byte) {
              return ('0' + (byte & 0xff).toString(16)).slice(-2);
            }).join('');

            const payload = {
              username: verifyStatus.payload.name,
              email: verifyStatus.payload.workEmail,
              image_hex: hexString,
            };

            console.log(payload);
            // will be enabled once mail api enabled
            // userActions.sendMail(payload);
          });
      }
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function copyToClipboard(id: string) {
    const targetId = document.getElementById(id);
    if (targetId !== null) {
      const markup = targetId.innerHTML;
      const tempInput = document.createElement('input');
      const body = document.getElementsByTagName('body')[0];
      body.appendChild(tempInput);
      tempInput.setAttribute('value', markup);
      tempInput.select();
      document.execCommand('copy');
      body.removeChild(tempInput);
    }
  }

  function downloadHtml(id: string) {
    const targetId = document.getElementById(id);
    if (targetId !== null) {
      const markup = targetId.innerHTML;
      let data = new Blob([markup], { type: 'data:attachment/text,' });
      let csvURL = window.URL.createObjectURL(data);
      let tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', 'Template.html');
      tempLink.click();
    }
  }

  function copySignature(id: string) {
    const elm = document.getElementById(id);

    if (elm && window.getSelection) {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(elm);
      selection?.removeAllRanges();
      selection?.addRange(range);
      document.execCommand('copy');
      selection?.removeAllRanges();
    }
  }

  return (
    <div className="row h-100 justify-content-center align-items-center">
      <div className="col-lg-8 py-4">
        <div className="text-center">
          <Box pb={5} className="col-md-6 m-auto" display="flex" justifyContent={'space-between'}>
            <Avatar
              sx={{
                width: '50px',
                height: '50px',
                border: '1px solid #23BB86',
                borderRadius: '50%',
                padding: 1.8,
                mr: 1,
              }}
              variant="rounded"
              alt=""
              src={Tick}
            />
            <Box
              sx={{
                width: '100%',
                borderTop: '2px dotted #23BB86',
                margin: '20px 2px 0 2px',
                transform: 'rotate(-0.07deg)',
              }}
            />
            <Avatar
              sx={{
                width: '50px',
                height: '50px',
                border: '1px solid #23BB86',
                borderRadius: '50%',
                padding: 1.5,
                ml: 1,
              }}
              variant="rounded"
              alt=""
              src={Download}
            />
          </Box>
          <Typography variant="h5" gutterBottom>
            Here's your new email signature
          </Typography>
          <Typography
            className="col-md-8 m-auto py-3"
            variant="caption"
            display="block"
            gutterBottom
          >
            It's high time to put it to work. Copy it by clicking one of the buttons below the
            preview, and add it to your email
            {/* client with our step-by-step guide. */}
          </Typography>
        </div>

        <Box
          height="auto !important"
          sx={{
            '& #signatureMarkup': {
              display: 'inline-block',
              p: 2,
            },
          }}
          className="signaturePreview"
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="signaturegenrator">
                  <EmailPreview />
                </div>
              </div>
            </div>
          </div>
        </Box>
        {/* <SignaturePreview /> */}
        <Stack direction="row" justifyContent="space-between" alignItems="" spacing={2} p={3}>
          <Button
            variant="contained"
            onClick={() => downloadHtml('signatureMarkup')}
            sx={{
              textTransform: 'none',
              '&.MuiButtonBase-root:hover': {
                bgcolor: '#FF8140',
              },
            }}
            color="secondary"
          >
            Download HTML
          </Button>
          <Button
            sx={{
              textTransform: 'none',
              '&.MuiButtonBase-root:hover': {
                bgcolor: '#FF8140',
              },
            }}
            color="secondary"
            variant="contained"
            onClick={() => copySignature('signatureMarkup')}
          >
            Copy Email Signature
          </Button>

          <Button
            sx={{
              textTransform: 'none',
              '&.MuiButtonBase-root:hover': {
                bgcolor: '#FF8140',
              },
            }}
            color="secondary"
            variant="contained"
            onClick={() => copyToClipboard('signatureMarkup')}
          >
            Copy Email Signature HTML CODE
          </Button>
        </Stack>
      </div>
    </div>
  );
};

export default DownloadEmail;
